import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/auth.service';
import videojs from 'video.js';
import 'videojs-contrib-hls';
import 'videojs-contrib-quality-levels';
import "video.js/dist/video-js.css";
import _ from "videojs-contrib-quality-levels";
import "video.js/dist/video-js.css";

require('videojs-contrib-quality-levels');
require('videojs-hls-quality-selector');

declare const videojs: any;
declare const Hls: any;
// declare const amp: any;

@Component({
  selector: 'app-video-preview',
  templateUrl: './video-preview.component.html',
  styleUrls: ['./video-preview.component.scss']
})

export class VideoPreviewComponent implements OnInit {
  @Input() public url;
  @Input() public thumbnail;
  @Input() public content;
  @Input() public isAdvertisement;
  @Input() public materialAd;
  @Input() public preview;
  @Input() public localPreview;
  @Input() public localPreviewType;
  @Input() public isAudioBook;

  @Output() closeAd = new EventEmitter();

  player: any;
  playlist = [];
  playindex = 0;
  encodingProcess: boolean = false;
  videoLoading = false;
  content_type: string = 'video';
  objectURL = [];
  source_for_ads: any;
  multiple_ads: any[];
  single_ad: any;
  midPostAds: any;
  preRoll_midRoll: boolean = false;
  midRollAd: any;
  playedPostRollAd: boolean = false;
  midClickThrough: any;
  postClickThrough: any;
  playingMidRollAd: boolean = false;
  playingPostRollAd: boolean = false;
  adPlayer_title: any;
  postStartTime: any;

  constructor(
    private activeModal: NgbActiveModal
  ) {

  }

  ngOnInit() {

    // const adVideo = document.getElementById('adVideoPlayer').style.display = 'none';
    // const adAudio = document.getElementById('adAudioPlayer').style.display = 'none';
    if (this.preview && this.content.preview_link && this.content.preview_link.preview_link == null && (this.content.preview_link.video_url.hls == null ? this.content.content_type : 'video')) {
      // if (this.preview && this.content.preview_link && this.content.preview_link.dash == null && this.content.preview_link.manifest == null) {
      this.encodingProcess = true;
      return;
    }
    else if (this.isAudioBook && this.content.audio_book && this.content.audio_book.audio_book != null) {
      this.content_type = 'audio';
      this.azureMediaAudiobook();
      return;
    } if (!this.preview && this.content && this.content.links_cloud == null) {
      this.encodingProcess = true;
      return;
    }
    else {
      this.encodingProcess = false;
    }

    if (this.isAdvertisement && this.materialAd[0] && this.materialAd[0].image && this.content && (this.content.content_type == 'video' || this.content.content_type == 'audio')) {
      this.content_type = (this.content && this.content.content_type) ? this.content.content_type : 'video';
      this.extract_from_blob();
    } else {
      if (this.isAdvertisement && this.materialAd.preview_link && this.materialAd.preview_link.hls != null) {
        // if (this.isAdvertisement && this.materialAd.preview_link && this.materialAd.preview_link.dash != null && this.materialAd.preview_link.manifest != null) {
        this.playlist.push({
          ...this.materialAd,
          links_cloud: this.materialAd.preview_link
        })
        this.content_type = this.materialAd.label;

        if (this.content && (this.content.content_type == 'video' || this.content.content_type == 'audio')) {
          this.playlist.push(this.content);
        }
      }
      else if (!this.isAdvertisement) {
        this.playlist.push(this.content);
        this.content_type = (this.content && this.content.content_type) ? this.content.content_type : 'video';
      }
      else {
        this.isAdvertisement = false;
        return;
      }
      this.setContent(this.playindex);
    }

    if (this.thumbnail) {
      this.thumbnail = this.thumbnail;
    }
    else {
      if (this.localPreview && this.localPreviewType == 'audio') {
        this.thumbnail = '/assets/images/icons/audio-primary-default-icon.jpg';
      } else if (this.localPreview && this.localPreviewType == 'video') {
        this.thumbnail = '/assets/images/icons/video-primary-default-icon.jpg';
      } else {
        this.thumbnail = '/assets/images/icons/video-primary-default-icon.jpg';
      }
    }

  }

  async ngAfterViewInit() {

    const video: any = document.getElementById('sxmvideo');

    if (video) {
      video.onended = () => {
        if (this.playlist[this.playindex + 1]) {
          if (this.isAdvertisement) {
            this.isAdvertisement = false;
            this.setContent(this.playindex + 1);
            video.removeAttribute('src');
            video.load();
            this.azureMedia();
          }
        } else {
          this.closeAd.emit(true);
        }
      };
    }
  }

  // Extract source from the blob link
  extract_from_blob() {
    document.getElementById('AdButton').style.display = 'none';
    let srcArray = [];
    let AdsArray = [];
    let ads = this.prepareAdObject();

    ads['mainProgram'] = {
      source: srcArray,
    };
    console.log('Blob URL', ads['midRoll'])

    if (ads['midRoll'].length > 1) {
      this.multiple_ads = ads['midRoll'].map(data => {
        return data.sourceUri
      })
      // Check if multiple_ads is true
      // Process multiple_ads
      const multiplePromises = this.multiple_ads.map((blobUrl, index) =>
        fetchAndParseXmlFromBlobUrl(blobUrl)
          .then(multipleAdsData => {
            if (multipleAdsData !== null) {
              if (ads && ads['midRoll'] && ads['midRoll'][index]) {
                let start_time_index = ads['midRoll'][index].startTime;
                const clickThrough = multipleAdsData.clickThrough; // Assuming this property exists in multipleAdsData
                const is_skip_enabled = ads['midRoll'][index].options.skipAd.enabled
                AdsArray.push({
                  url: multipleAdsData.cdataContent,
                  title: multipleAdsData.title,
                  startTime: start_time_index,
                  clickThrough: clickThrough,
                  skip_enabled: is_skip_enabled
                })
              }
              console.log('Multiple Ads Data:', AdsArray);
            } else {
              console.log('Failed to fetch multiple ads data');
            }
          })
      );
      Promise.all(multiplePromises)
        .then(() => {
          this.azureMediaVast(AdsArray);
          console.log('All multiple ads processed');
        })
        .catch(error => {
          console.error('Error processing multiple ads:', error);
        });
    } else {
      this.single_ad = ads['midRoll'].map(data => {
        return data.sourceUri
      })
      fetchAndParseXmlFromBlobUrl(this.single_ad)
        .then(singleAdsData => {
          if (singleAdsData !== null) {
            AdsArray.push({
              url: singleAdsData.cdataContent,
              title: singleAdsData.title,
              startTime: ads['midRoll'][0].startTime,
              clickThrough: singleAdsData.clickThrough,
              skip_enabled: ads['midRoll'][0].options.skipAd.enabled
            })
            this.azureMediaVast(AdsArray);
            console.log('Single Ads Data:', AdsArray);
          } else {
            console.log('Failed to fetch single ads data');
          }
        });
    }

    async function fetchAndParseXmlFromBlobUrl(blobUrl: string): Promise<{ cdataContent: string; title: string, clickThrough: string }> {
      try {
        const response = await fetch(blobUrl);
        if (response.ok) {
          const xmlContent = await response.text();

          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(xmlContent, 'text/xml');

          const mediaFileNode = xmlDoc.querySelector('MediaFile');
          const clickThrough = xmlDoc.querySelector('ClickThrough').textContent;
          const title = xmlDoc.querySelector('AdTitle').textContent || '';
          const cdataNode = mediaFileNode.firstChild as CDATASection;
          if (cdataNode && clickThrough) {
            const cdataContent = cdataNode.nodeValue || '';
            return { cdataContent, title, clickThrough };
          }
        } else {
          console.error('Failed to fetch XML content from Blob URL:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching XML content from Blob URL:', error);
      }
    }
  }

  azureMediaAudiobook() {
    var that = this;
    var options = {
      // controlBar: {
      //   volumePanel: {
      //     inline: false,
      //     vertical: true
      //   },
      // },
      logo: { enabled: false },
      qualitySelector: true,
      poster: ""
    };
    this.thumbnail = environment.url + this.thumbnail;
    this.player = videojs(('my-player2'), { /* Options */
      options
    }, function () {
    });

    let srcArray = [];


    let obj = {};
    obj = {
      src: this.content.audio_book.audio_book,
      type: "audio/mpeg",
    }
    srcArray.push(obj)

    // Object.entries(this.content.audio_book.dash).forEach(([key, value]) => {
    //   let obj = {};
    //   obj = {
    //     src: value,
    //     type: "application/vnd.ms-sstr+xml"
    //   }
    //   srcArray.push(obj)
    // });
    // srcArray.push({
    //   src: this.content.audio_book.manifest,
    //   type: "application/vnd.ms-sstr+xml"
    // })
    this.player.title = this.content.out_line ? this.content.out_line : this.content.name
    this.player.on(['loadstart', 'play', 'playing', 'firstplay', 'pause', 'ended', 'adplay', 'adplaying', 'adfirstplay', 'adpause', 'adended', 'contentplay', 'contentplaying', 'contentfirstplay', 'contentpause', 'contentended', 'contentupdate'], function (e) {
      // console.warn('VIDEOJS player event: ',  e.type);
    });
    document.getElementById('adVideoPlayer').style.display = 'none';
    document.getElementById('adAudioPlayer').style.display = 'none';
    document.getElementById('skipButton').style.display = 'none';
    document.getElementById('AdButton').style.display = 'none';
    document.getElementById('clickThroughLink').style.display = 'none';
    this.player.src(srcArray)
    this.player.httpSourceSelector(srcArray);
    if (this.content.audio_book.thumbnail)
      this.player.poster(this.content.audio_book.thumbnail);
  }

  azureMedia() {

    if (!this.encodingProcess && !this.localPreview) {

      var options = {
        // controlBar: {
        //   volumePanel: {
        //     inline: false,
        //     vertical: true
        //   },
        // },
        controls: true,
        logo: { enabled: false },
        qualitySelector: true,
        autoplay: true,
        poster: ""
      };

      if (videojs.getPlayer("my-player1")) {
        videojs("my-player1").dispose();
      } else if (videojs.getPlayer("my-player2")) {
        videojs("my-player2").dispose();
      }
      this.player = videojs(((this.content_type == 'audio') ? 'my-player2' : 'my-player1'), { /* Options */
        options
      }, function () {});

      let srcArray = [];
      if (this.content.content_type == 'video') {
        if (this.preview) {
          if (this.content.preview_link.preview_link.video_url == null) {
            srcArray.push({
              src: this.content.preview_link.preview_link,
              type: "video/mp4"
            })
          } else {
            srcArray.push({
              src: this.content.preview_link.video_url.hls,
              type: "application/x-mpegURL",
            })
          }
        }
        else {
          if (this.content.links_cloud.video_url.mp4 == null) {
            srcArray.push({
              src: this.content.links_cloud.video_url.hls,
              type: "application/X-mpegURL",
            })
          } else {
            srcArray.push({
              src: this.content.links_cloud.video_url.mp4,
              type: "video/mp4",
            })
          }
        }
      }
      else {
        if (this.preview) {

          srcArray.push({
            src: this.content.preview_link.preview_link,
            type: "audio/mpeg",
          })
        }
        // for ManageAdvertsiment video_links
        else if (this.content.label == 'video') {
          // if (this.content.links_cloud == null) {
          srcArray.push({
            src: this.content.link,
            type: "video/mp4",
          })
          // } else {
          //   srcArray.push({
          //     src: this.content.links_cloud,
          //     type: "application/x-mpegURL",
          //   })
          // }
        }
        else if (this.content.label == 'audio') {
          srcArray.push({
            src: this.content.link,
            type: "audio/mpeg",
          })
        }
        else {
          if (this.content.links_cloud == null) {
            srcArray.push({
              src: this.content.links_cloud.video_url.hls,
              type: "application/x-mpegURL",
            })
          } else {
            srcArray.push({
              src: this.content.links_cloud.preview_link,
              type: "audio/mpeg",
            })
          }
        }
      };
      this.player.title = this.content.out_line ? this.content.out_line : this.content.name
      this.player.on(['loadstart', 'play', 'playing', 'firstplay', 'pause', 'ended', 'adplay', 'adplaying', 'adfirstplay', 'adpause', 'adended', 'contentplay', 'contentplaying', 'contentfirstplay', 'contentpause', 'contentended', 'contentupdate'], function (e) {});
      document.getElementById('adVideoPlayer').style.display = 'none';
      document.getElementById('adAudioPlayer').style.display = 'none';
      document.getElementById('skipButton').style.display = 'none';
      document.getElementById('AdButton').style.display = 'none';
      document.getElementById('clickThroughLink').style.display = 'none';
      this.player.src(srcArray)
      this.player.httpSourceSelector(srcArray);
      if (this.thumbnail) {
        this.player.poster(this.thumbnail);
      }
    }
  }

  setContent(index) {

    this.content = this.playlist[index];

    if (this.content && !this.content.image)
      this.isAdvertisement = false;

    if (!this.preview) {
      if (this.content && this.content.thumb) {
        if (!this.thumbnail) {
          this.thumbnail = environment.url + this.content.thumb;
        }

      }
      else {
        this.thumbnail = '/assets/images/icons/video-primary-default-icon.jpg';
        if (this.localPreview && this.localPreviewType == 'audio') {
          this.thumbnail = '/assets/images/icons/audio-primary-default-icon.jpg';
        } else if (this.localPreview && this.localPreviewType == 'video') {
          this.thumbnail = '/assets/images/icons/video-primary-default-icon.jpg';
        } else {
          this.thumbnail = '/assets/images/icons/video-primary-default-icon.jpg';
        }
      }

      if (this.isAdvertisement) {
        this.url = this.content.image;
      }
      else {
        this.content_type = (this.content && this.content.content_type) ? this.content.content_type : 'video';
      }

      if (this.content && this.content.links_cloud) {
        this.url = '';
        this.azureMedia();
      }
    }
    else {
      if (this.content && this.content.preview_link) {
        this.azureMedia();
      }
    }
  }

  closeDialog() {
    // if (this.content && this.content.preview_link && this.preview) {
    //   this.player.dispose();
    // }
    this.activeModal.close();
  }

  azureMediaVast(data) {
    if (this.isAdvertisement && !this.encodingProcess && !this.localPreview) {
      var that = this;
      var options = {
        // controlBar: {
        //   volumePanel: {
        //     inline: false,
        //     vertical: true
        //   },
        // },
        controls: true,
        logo: { enabled: false },
        qualitySelector: true,
        autoplay: true,
        poster: ""
      };
      let srcArray = [];

      if (this.preview) {
        if (this.content_type == 'video') {
          srcArray.push({
            src: this.content.preview_link.video_url.hls,
            type: "application/x-mpegURL",
          })
        }
        else {
          srcArray.push({
            src: this.content.links_cloud.video_url.hls,
            type: "application/x-mpegURL",
          })
        }
        // Object.entries(this.content.preview_link.hls).forEach(([key, value]) => {
        //   let obj = {};
        //   obj = {
        //     src: value,
        //     type: "application/x-mpegURL",
        //     //withCredentials: true
        //   }
        //   srcArray.push(obj)
        // });
        srcArray.push({
          src: this.content.preview_link.video_url.hls,
          type: "application/x-mpegURL",
        })
      }
      else {
        // Object.entries(this.content.links_cloud.hls).forEach(([key, value]) => {
        //   let obj = {};
        //   obj = {
        //     src: value,
        //     type: "application/x-mpegURL",
        //   }
        //   srcArray.push(obj);
        // });
        srcArray.push({
          src: this.content.links_cloud.preview_link,
          type: "application/x-mpegURL",
        })
      }

      this.source_for_ads = data;
      if (this.source_for_ads.length >= 2) {
        this.preRoll_midRoll = true;
        this.midPostAds = this.source_for_ads.map(ad => ({
          url: ad.url,
          title: ad.title,
          startTime: ad.startTime,
          clickThrough: ad.clickThrough,
          skip_enabled: ad.skip_enabled
        }));
      } else {
        this.midPostAds = this.source_for_ads
      }

      // Check if player is already intialized
      if (videojs.getPlayer("my-player1") && videojs.getPlayer("adVideoPlayer")) {
        videojs("my-player1").dispose();
        videojs("adVideoPlayer").dispose();
      } else if (videojs.getPlayer("my-player2") && videojs.getPlayer("adAudioPlayer")) {
        videojs("my-player2").dispose();
        videojs("adAudioPlayer").dispose();
      }
      var player = videojs(((this.content_type == 'audio') ? 'my-player2' : 'my-player1'), function () { });
      var player_type = player.id_;
      var adPlayer = videojs((this.content_type == 'audio') ? 'adAudioPlayer' : 'adVideoPlayer');
      var ad_player_type = adPlayer.id_;

      // intialize the player and ad title
      player.title = this.content.out_line ? this.content.out_line : this.content.name
      this.adPlayer_title = player.title;

      if (this.thumbnail) {
        player.poster(this.thumbnail);
      }
      if (this.content_type == 'audio') {
        adPlayer.poster(this.thumbnail);
      }

      // Hide skip && clickthrough && adButton button and ad player
      document.getElementById('advertismentLabel').style.display = 'none';
      document.getElementById('clickThroughLink').style.display = 'none';
      document.getElementById('AdButton').style.display = 'none';
      document.getElementById(ad_player_type).style.display = 'none';
      document.getElementById('skipButton').style.display = 'none';
      var mainVideoPausedTime = null; // Store the paused time of the main video
      var adStarted = false;
      let playingMidRollAd;
      let playingPostRollAd;

      var mainVideo = srcArray[0].src
      if (this.preRoll_midRoll === true) {
        var midrollAdURL = this.midPostAds[0].url
        var midStartTime = this.midPostAds[0].startTime
        var midRollTitle = this.midPostAds[0].title
        this.midClickThrough = this.midPostAds[0].clickThrough
        var midSkipEnabled = this.midPostAds[0].skip_enabled
        var postRollAdURL = this.midPostAds[1].url
        var postStartTime = this.postStartTime = this.midPostAds[1].startTime
        var postRollTitle = this.midPostAds[1].title
        this.postClickThrough = this.midPostAds[1].clickThrough
        var multipleAd_redirect_link = {
          midRollLink: this.midClickThrough,
          postRollLink: this.postClickThrough
        }
        var postSkipEnabled = this.midPostAds[0].skip_enabled
      } else if(this.midPostAds[0].startTime >= 5) {
        var postRollAdURL = this.midPostAds[0].url
        var postStartTime = this.postStartTime = this.midPostAds[0].startTime
        var postRollTitle = this.midPostAds[0].title
        this.midClickThrough = this.midPostAds[0].clickThrough
        var postAdClick = this.midClickThrough
        var postSkipEnabled = this.midPostAds[0].skip_enabled
      } else {
        var midrollAdURL = this.midPostAds[0].url
        var midStartTime = this.midPostAds[0].startTime
        var midRollTitle = this.midPostAds[0].title
        this.midClickThrough = this.midPostAds[0].clickThrough
        var singleAd_redirect_link = { midRollLink: this.midClickThrough }
        var midSkipEnabled = this.midPostAds[0].skip_enabled
      }

      let hasSkipped = false; // Track whether the ad has been skipped

      player.src(mainVideo);
      player.on('timeupdate', function () {
        var currentTime = player.currentTime();
        if (currentTime >= midStartTime && !adStarted) {
          player.pause();
          playingMidRollAd = true;
          adStarted = true;
          document.getElementById(ad_player_type).style.display = 'block';
          mainVideoPausedTime = player.currentTime();
          player.el().style.display = 'none';
          adPlayer.el().style.display = 'block';
          adPlayer.controlBar.progressControl.disable();
          // shows skip && clickthrough && adButton button and ad player
          document.getElementById('materialTitle').style.display = 'none';
          document.getElementById('advertismentLabel').style.display = 'block';
          document.getElementById('clickThroughLink').style.display = 'block';
          document.getElementById('AdButton').style.display = 'block';
          // Set the ad source dynamically
          adPlayer.src({ src: midrollAdURL });
          adPlayer.load(); // Load the new source
          adPlayer.play();
        }

        // Get the ad video duration
        adPlayer.on('loadedmetadata', function() {
         this.adDuration = adPlayer.duration();
        });

        // to fix the skip-button issue when the ad ended
        adPlayer.on('timeupdate', function() {
          var adCurrentTime = adPlayer.currentTime();
          if(!hasSkipped && adCurrentTime > 5) {
            document.getElementById('skipButton').style.display = 'block';
          }

          if(adCurrentTime >= this.adDuration) {
            document.getElementById('skipButton').style.display = 'none';
          }
        })

        // skip-button for ads
        var skipButton = document.getElementById('skipButton');
        skipButton.addEventListener('click', function () {
          if (!hasSkipped) {
            adPlayer.pause();
            // Hide skip && clickthrough button and ad player
            hasSkipped = true;
            document.getElementById('skipButton').style.display = 'none';
            document.getElementById('materialTitle').style.display = 'block';
            document.getElementById('advertismentLabel').style.display = 'none';
            document.getElementById('clickThroughLink').style.display = 'none';
            document.getElementById('AdButton').style.display = 'none';
            adPlayer.el().style.display = 'none';
            // Resume main video playback
            player.el().style.display = 'block';
            // Resume the main video from where it was paused
            if (mainVideoPausedTime !== null) {
              document.getElementById('skipButton').style.display = 'none';
              player.currentTime(mainVideoPausedTime);
              mainVideoPausedTime = null;
              player.play();
            }
          }
        });

        // Listen for the 'ended' event of the adPlayer
        adPlayer.on('ended', function () {
          console.log("ad has ended");
          adPlayer.pause();
          // Hide skip && clickthrough button and ad player
          document.getElementById('materialTitle').style.display = 'block';
          document.getElementById('advertismentLabel').style.display = 'none';
          document.getElementById('clickThroughLink').style.display = 'none';
          document.getElementById('AdButton').style.display = 'none';
          document.getElementById('skipButton').style.display = 'none';
          adPlayer.el().style.display = 'none';
          // Resume main video playback
          player.el().style.display = 'block';
          // Resume the main video from where it was paused
          if (this.playedPostRollAd === true) {
            videojs(player_type).dispose();
            videojs(ad_player_type).dispose();
            adPlayer.pause();
            if (videojs.getPlayer(player_type)) {
              videojs(player_type).dispose();
            }
          } else if (mainVideoPausedTime !== null) {
            player.currentTime(mainVideoPausedTime);
            mainVideoPausedTime = null;
            player.play();
          }
        });
      });

      // video-ended and postroll ad
      player.on('ended', () => {
        // Play the post-roll ad when the main video ends
        var currentTime = player.currentTime();
        if (this.postStartTime) {
          if (this.postStartTime >= currentTime -1) {
            // if (this.preRoll_midRoll === true) {
            playingPostRollAd = true
            adStarted = true;
            player.pause();
            // Hide skip && clickthrough button and ad player
            document.getElementById('materialTitle').style.display = 'none';
            document.getElementById('advertismentLabel').style.display = 'block';
            document.getElementById('clickThroughLink').style.display = 'block';
            document.getElementById('AdButton').style.display = 'block';
            document.getElementById(ad_player_type).style.display = 'block';
            player.el().style.display = 'none';
            adPlayer.el().style.display = 'block';
            adPlayer.controlBar.progressControl.disable();

            adPlayer.src(postRollAdURL || midrollAdURL)
            adPlayer.load();
            adPlayer.play();
            this.playedPostRollAd = true;
          }
        }
      });

      // clickThrough option
      var clickThroughButton = document.getElementById('clickThroughLink');
      clickThroughButton.addEventListener('click', function () {
        adPlayer.pause();
        if (!multipleAd_redirect_link) {
          if (singleAd_redirect_link) {
            window.open(singleAd_redirect_link.midRollLink, "_blank");
          } else if(postAdClick) {
            window.open(postAdClick, "_blank");
          }
        } else if(playingMidRollAd === true) {
            window.open(multipleAd_redirect_link.midRollLink, "_blank");
          } else {
            window.open(multipleAd_redirect_link.postRollLink, "_blank");
          }
      });
    }
    // this.player = videojs(((this.content_type == 'audio') ? 'my-player2' : 'my-player1'), { /* Options */
    // options
    // }, function () {
    //   this.addEventListener('ended', () => {
    //     var src = [];
    //     if (that.playlist[that.playindex + 1]) {
    //       if (that.isAdvertisement) {
    //         that.isAdvertisement = false;
    //         that.setContent(that.playindex + 1);
    //         that.azureMedia();
    //       }
    //     }
    //     else {
    //       that.closeAd.emit(1);
    //     }
    //   })
    //   this.player.ads();
    // });
    // this.player.src(srcArray);
    // this.player.httpSourceSelector(srcArray);
  }

  prepareAdObject() {
    let preRoll = {
      sourceUri: '',
      options:
      {
        skipAd:
        {
          enabled: true,
          offset: 5
        }
      }
    }

    // let postRoll = {
    //   sourceUri: '',
    //   options:
    //   {
    //     skipAd:
    //     {
    //       enabled: true,
    //       offset: 5
    //     }
    //   }
    // }
    let ads = {
      midRoll: []
    };
    if (this.materialAd[0]) {
      this.materialAd.forEach(element => {
        let midRoll = {
          sourceUri: '',
          startTime: 0,
          options:
          {
            skipAd:
            {
              enabled: true,
              offset: 5
            }
          }
        }
        if (this.content.content_type == 'video') {
          if (element.slot && parseInt(element.slot.start_at) == 0 && !element.slot.is_last) {
            midRoll.sourceUri = this.generateVastString(element);
            // midRoll.sourceUri = this.generateVastString(element);
            midRoll.startTime = 0.5;
            if (parseInt(element.advertisement_length) >= 5) {
              midRoll.options.skipAd.enabled = true;
            }
            ads.midRoll.push(midRoll);
          } else {
            // if (!element.slot.is_last) {
            midRoll.sourceUri = this.generateVastString(element);
            midRoll.startTime = parseFloat(element.slot.start_at);
            if (parseInt(element.advertisement_length) >= 5) {
              midRoll.options.skipAd.enabled = true;
            }
            ads.midRoll.push(midRoll);
            // } else if (element.slot.is_last) {
            // midRoll.sourceUri = this.generateVastString(element);
            // midRoll.startTime = parseInt(element.slot.start_at);
            // if (parseInt(element.advertisement_length) <= 5) {
            //   // postRoll.options.skipAd.enabled = false;
            // }
            // ads.midRoll.push(midRoll);
          }
        } else if (this.content.content_type == 'audio') {
          midRoll.sourceUri = this.generateVastString(element);
          midRoll.startTime = 0.5;
          if (parseInt(element.advertisement_length) <= 5) {
            midRoll.options.skipAd.enabled = false;
          }
          ads.midRoll.push(midRoll);
        }
      });


      if (preRoll.sourceUri) {
        ads['preRoll'] = preRoll;
      }
      // if (postRoll.sourceUri) {
      //   ads['postRoll'] = postRoll;
      // }
      return ads;

    }
  }

  generateVastString(materialAd) {
    const createVast = require('vast-builder');
    const vast3 = createVast.v3();
    let link = (materialAd.link.indexOf('://') === -1) ? 'http://' + materialAd.link : materialAd.link;
    vast3.attachAd()
      .attachInLine()
      // .addImpression(materialAd.link)
      // .addAdSystem('Society')
      .addAdTitle(materialAd.name)
      .attachCreatives()
      .attachCreative()
      .attachLinear()
      // .attachTrackingEvents()
      // .attachTracking('content', { event: 'start' }).back()
      .addDuration('00:00:00')
      .attachMediaFiles()
      .attachMediaFile(materialAd.image, {
        delivery: 'streaming',
        type: 'video/mp4',
        scalable: 'true'
      })
      .back()
      .attachVideoClicks()
      .addClickThrough(
        link, {}
      ).back();
    // .attachStaticResource('ressource_link', { creativeType: 'image/jpeg' })

    const render = vast3.toXml();
    var data = new Blob([render], { type: 'application/xml' });
    this.objectURL.push(data);
    return window.URL.createObjectURL(data);

  }
  ngOnDestroy() {
    if (this.isAudioBook && this.content.audio_book && this.content.audio_book.audio_book != null) {
      // if (this.isAudioBook && this.content.audio_book && this.content.audio_book.dash != null && this.content.audio_book.manifest != null) {
      this.player.dispose();
    }
    if (this.objectURL.length) {
      this.objectURL.forEach((element) => {
        window.URL.revokeObjectURL(element);
      });
    }
  }

  private handleVideoEnded = () => {
    this.player.dispose();
    console.log('Video ended.');
    // Video has ended, so you can handle it here
  };

}
